module.exports = __webpack_public_path__ + "img/ic-dash-report.5bed6684.svg";